// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_q-1";
export var movingGradient = "_q-4";
export var movingGradientBlock = "_q-2";
export var skeleton = "_q-0";
export var skeletonText = "_q-3";